import React, { Component } from 'react';

class BookingContainer extends Component {
  render() {
    return (
      <div id="booking-container">
        <iframe
          title="village hall booking" height="3650px" src="https://forms.office.com/Pages/ResponsePage.aspx?id=otV96FOHBEWwsRs_4y7kqplhinPMlnJEijddt1oekctUQTkzNk1DM1YxNEJHWkZEUFpURVkxUTA2Si4u&embed=true"
          frameborder="0" marginwidth="0" marginheight="0" allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen>
        </iframe>
      </div>
    );
  }
}

export default BookingContainer;


// WEBPACK FOOTER //
// ./src/views/bookingContainer.js